module.exports = __webpack_public_path__ + "34d0c1c843c0f7738e820be50540a0ac.png";